import MediaAssetService from '@services/MediaAssetService';
import type { MediaAssetServiceResponse } from '@shared-types/mediaAssets.types';
import { getCountdownInterval } from '@utilities/countdown-interval';

export default class VideoAvailabilityPlugin {
  options: any;
  dom: HTMLElement;
  translations: any;
  target: HTMLElement[];

  constructor(dom: HTMLElement, options: any) {
    const defaults = {
      videoIds: [],
      selector: null,
    };

    this.options = {
      ...defaults,
      ...options,
    };

    this.dom = dom;

    this.translations = this.options?.translations?.availability;
  }

  off() {
    MediaAssetService.off(this.options.videoIds, this._check, this);
  }

  init() {
    this.target = [this.dom];

    if (this.options.selector) {
      this.target = Array.from(this.dom.querySelectorAll<HTMLElement>(this.options.selector));
      this.options.videoIds = this.target.map((el) => el.dataset.videoid);
    }

    if (!this.options.videoIds || !this.options.videoIds.length) return;

    this._attach();
  }

  _attach() {
    MediaAssetService.on(this.options.videoIds, this._check, this);
  }

  _check(videos: MediaAssetServiceResponse[] = []) {
    if (this.options.selector) {
      this.options.videoIds.forEach((id) => {
        const video = videos.find((v) => v.mediaAssetId === `${id}`);
        const available = video?.status === 'AVAILABLE';
        const elements = this.target.filter((el) => el.dataset.videoid === `${id}`);
        elements.forEach((element) => this._setCssClasses(element, available, video?.availableAt));
      });
    } else {
      const available = this.options.videoIds.every((id) =>
        videos.some((v) => v.mediaAssetId === `${id}` && v.status === 'AVAILABLE'),
      );
      const [highlights] = videos;
      const { availableAt } = highlights ?? {};
      this._setCssClasses(this.dom, available, availableAt);
    }
  }

  _setCssClasses(el: HTMLElement, available: boolean, availableAt: string) {
    el.classList.toggle('video-available', available);
    el.classList.toggle('video-not-available', !available);
    if (availableAt) {
      this._setCountdown(availableAt);
    }
  }

  _setCountdown(startDate: string) {
    const textContainer = this.dom.querySelector('.js-video-not-available');
    if (textContainer) {
      const { hours, minutes } = getCountdownInterval(startDate);
      let translatedText = '';

      if (hours > 0) {
        translatedText = this.translations?.hours?.replace('{hours}', hours).replace('{minutes}', minutes);
      } else if (minutes > 0) {
        translatedText = this.translations?.minutes?.replace('{minutes}', minutes);
      } else {
        translatedText = this.translations?.zero;
      }

      textContainer.innerHTML = translatedText;
    }
  }
}
